import sdl from '@jds/react-generated-sdl/JDSFileUploaderControl';
import type { JDSFileUploaderControlProps } from './interface';

import { componentsMap } from '../../../generators/componentMap';
import {
  createComponent,
  getCustomJSON,
  useTokenValues
} from '@jds/react-engine';

import { withLogic } from '../logic';

const Component = (props: JDSFileUploaderControlProps) => {
  const { platform } = useTokenValues();

  const json = sdl;
  const { custom = '', ...rest } = props as any;
  return createComponent(
    json,
    rest,
    'JDSFileUploaderControl',
    componentsMap,
    getCustomJSON(custom || '') || {}
  );
};

const FileUploaderControl = withLogic(
  Component
) as React.FC<JDSFileUploaderControlProps> & { slotName?: string };

FileUploaderControl.displayName = 'FileUploaderControl';
FileUploaderControl.slotName = 'jds_file_uploader_control';

export { FileUploaderControl, type JDSFileUploaderControlProps };
